<style src="css/serveInfo.css" scoped></style>
<template>
    <div style="padding-top: .98rem;">
        <topbar text="服务信息"></topbar>
        <div class="mainBox">
            <div class="fff">
                <div class="procedure">
                    <div class="procedureItem">
                        预约时间
                        <!--                    <div class="procedureIcon p1"></div>-->

                    </div>
                    <div class="procedureItem">
                        补充信息
                        <!--                    <div class="procedureIcon p2"></div>-->

                    </div>
                    <div class="procedureItem">
                        等待咨询
                        <!--                    <div class="procedureIcon p3"></div>-->

                    </div>
                    <div class="procedureItem">
                        开始咨询
                        <!--                    <div class="procedureIcon p4"></div>-->
                    </div>

                </div>
                <div class="procedureLine">
                    <div class="yuan"></div>
                    <div class="yLine"></div>
                    <div class="yuan"></div>
                    <div class="yLine"></div>
                    <div class="yuan"></div>
                    <div class="yLine"></div>
                    <div class="yuan"></div>
                </div>
                <div class="title">服务信息</div>
                <div class="infoBox" >
                    <div class="infoItem">
                        <div class="infoKey">预约老师</div>
                        <div class="infoValue">{{userBespeakDetail.doctorName}}</div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">咨询方式</div>
                        <div class="infoValue">{{userBespeakDetail.scaleUserBespeak.serveType | isServeType}}</div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">咨询次数</div>
                        <div class="infoValue">{{userBespeakDetail.scaleUserBespeak.bespeakTimes}}</div>
                    </div>
                    <div class="infoItem lastItem">
                        <div class="infoKey">预约时间</div>
                        <div class="infoValue">{{userBespeakDetail.scaleUserBespeak.bespeakDate}}</div>
                    </div>
                </div>
            </div>
            <div class="fffItem">
                <div class="title">来访者信息</div>
                <div class="infoBox">
                    <div class="infoItem">
                        <div class="infoKey">姓名</div>
                        <div class="infoValue">{{userBespeakDetail.userName}}</div>
                    </div>
                    <div class="infoItem lastItem">
                        <div class="infoKey">手机号</div>
                        <div class="infoValue">{{userBespeakDetail.userPhone}}</div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">出生地</div>

                        <div class="radioBox" @click="scaleUserBespeakRegister.birthPlace=1">
                            <div class="radioIcon" :class="{active:scaleUserBespeakRegister.birthPlace===1}"></div>
                            城市
                        </div>
                        <div class="radioBox" @click="scaleUserBespeakRegister.birthPlace=0">
                            <div class="radioIcon" :class="{active:scaleUserBespeakRegister.birthPlace===0}"></div>
                            农村
                        </div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">是否独生子女</div>
                        <div class="infoValue" v-if="scaleUserBespeakRegister.onlyChild > 0 || scaleUserBespeakRegister.onlyChild===0" @click="openOnlyChild">{{scaleUserBespeakRegister.onlyChild | isOnlyChild}}</div>
                        <div class="toSelect" v-else @click="onlyChildStatus=true" >请选择 <div class="more"></div></div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">宗教信仰</div>
                        <div class="infoValue" v-if="scaleUserBespeakRegister.religiousBeliefs!==''" @click="openReligiousBeliefs">{{scaleUserBespeakRegister.religiousBeliefs | isReligiousBeliefs}}</div>
                        <div class="toSelect" v-else @click="religiousBeliefsStatus=true">请选择 <div class="more"></div></div>
                    </div>
                    <div class="zhzz">
                        <div class="infoKey1">在杭住址(寝室或外宿地址)</div>
                        <input type="text" placeholder="请输入住址" v-model="scaleUserBespeakRegister.address">
                    </div>
                </div>
            </div>

            <div class="fffItem">
                <div class="title">家庭状况</div>
                <div class="infoItem">
                    <div class="infoKey">父亲年龄</div>
                    <input type="number" v-model="scaleUserBespeakRegister.fatherAge" class="minInput" placeholder="请输入"> 岁
                </div>
                <div class="infoItem">
                    <div class="infoKey">健在</div>
                    <div class="radioBox" @click="scaleUserBespeakRegister.fatherLive=0">
                        <div class="radioIcon" :class="{active:scaleUserBespeakRegister.fatherLive === 0}"></div>
                        是
                    </div>
                    <div class="radioBox" @click="scaleUserBespeakRegister.fatherLive=1">
                        <div class="radioIcon" :class="{active:scaleUserBespeakRegister.fatherLive === 1}"></div>
                        否
                    </div>
                </div>
                <div class="infoItem lastItem">
                    <div class="infoKey">职业</div>
                    <div class="infoValue"><input type="text" v-model="scaleUserBespeakRegister.fatherWork" placeholder="请输入" class="medium"></div>
                </div>
                <div class="infoItem lastItem">
                    <div class="infoKey">学历</div>
                    <div class="infoValue"><input type="text" v-model="scaleUserBespeakRegister.fatherEducation" placeholder="请输入" class="minInput"></div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">母亲年龄</div>
                    <input type="number" v-model="scaleUserBespeakRegister.motherAge" class="minInput" placeholder="请输入"> 岁
                </div>
                <div class="infoItem">
                    <div class="infoKey">健在</div>
                    <div class="radioBox" @click="scaleUserBespeakRegister.motherLive=0">
                        <div class="radioIcon" :class="{active:scaleUserBespeakRegister.motherLive === 0}"></div>
                        是
                    </div>
                    <div class="radioBox" @click="scaleUserBespeakRegister.motherLive=1">
                        <div class="radioIcon" :class="{active:scaleUserBespeakRegister.motherLive === 1}"></div>
                        否
                    </div>
                </div>
                <div class="infoItem lastItem">
                    <div class="infoKey">职业</div>
                    <div class="infoValue"><input type="text" v-model="scaleUserBespeakRegister.motherWork" placeholder="请输入" class="medium"></div>
                </div>
                <div class="infoItem lastItem">
                    <div class="infoKey">学历</div>
                    <div class="infoValue"><input type="text" v-model="scaleUserBespeakRegister.motherEducation" placeholder="请输入" class="minInput"></div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">家庭结构</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.familyState===''" @click="familyStateStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="familyStateStatus=true">{{scaleUserBespeakRegister.familyState | isFamilyState}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">父母婚姻状况</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.parentMarital===''" @click="parentMaritalStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="parentMaritalStatus=true">{{scaleUserBespeakRegister.parentMarital | isParentMarital}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">家庭经济条件</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.familyEconomic===''" @click="familyEconomicStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="familyEconomicStatus=true">{{scaleUserBespeakRegister.familyEconomic | isFamilyEconomic}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">家族精神类疾病史</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.familyMentalIllness===''" @click="familyMentalIllnessStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="familyMentalIllnessStatus=true">{{scaleUserBespeakRegister.familyMentalIllness | isFamilyMentalIllness}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">家庭氛围</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.familyHappy===''" @click="familyHappyStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="familyHappyStatus=true">{{scaleUserBespeakRegister.familyHappy | isFamilyHappy}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">寄养/留守经历</div>
                    <div class="toSelect" v-if="!liveStateList.find(el => el.status == true)" @click="liveStateStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="liveStateStatus=true"><span v-for="item in liveStateList" :key="item.key">{{item.status?item.name:''}} </span></div>
                </div>
            </div>

            <div class="fffItem" style="margin-bottom: 0">
                <div class="title">个人状况</div>
                <div class="infoItem">
                    <div class="infoKey">对本专业的满意度</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.majorSatisfaction===''" @click="majorSatisfactionStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="majorSatisfactionStatus=true">{{scaleUserBespeakRegister.majorSatisfaction | isMajorSatisfaction}}</div>
                </div>
                <div class="infoItem" style="height: 2.2rem">
                    <div class="infoKey">是否经历了负性生活事件情况，如重要他人去世、被校园霸凌、失恋等</div>
                    <div class="infoValue maxWidth" v-if="scaleUserBespeakRegister.incident!==''" @click="openIncident">{{scaleUserBespeakRegister.incident | isIncident}}</div>
                    <div class="toSelect" v-else @click="incidentStatus=true">请选择 <div class="more"></div></div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">您是否曾自伤或自杀</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.selfInflicted===''" @click="selfInflictedStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="selfInflictedStatus=true">{{scaleUserBespeakRegister.selfInflicted | isSelfInflicted}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">个人精神障碍史</div>
                    <div class="infoValue maxWidth" v-if="scaleUserBespeakRegister.selfMentalIllness!==''" @click="openSelfMentalIllness">{{scaleUserBespeakRegister.selfMentalIllness | isSelfMentalIllness}}</div>
                    <div class="toSelect" v-else @click="selfMentalIllnessStatus=true">请选择 <div class="more"></div></div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">咨询经历</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.consultHistory===''" @click="consultHistoryStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="consultHistoryStatus=true">{{scaleUserBespeakRegister.consultHistory | isConsultHistory}}</div>
                </div>
                <div class="infoItem">
                    <div class="infoKey">评估目前压力水平</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.pressureValue===''" @click="pressureValueStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue" v-else @click="pressureValueStatus=true">{{scaleUserBespeakRegister.pressureValue | isPressureValue}}</div>
                </div>
                <div class="infoItem" style="height: 1.5rem">
                    <div class="infoKey">目前主要问题(可多选)</div>
                    <div class="toSelect" v-if="scaleUserBespeakRegister.troubles===''" @click="troublesStatus=true">请选择 <div class="more"></div></div>
                    <div class="infoValue maxWidth" v-else @click="troublesStatus=true">{{scaleUserBespeakRegister.troubles}}</div>
                </div>
            </div>
            <div class="c-nextBox">
                <div class="nextBtn" @click="next">下一步</div>
            </div>

        </div>

        <div class="maskBox" v-if="birthplaceStatus" @click="birthplaceStatus=false">
            <div class="maskTitle" @click.stop>选择出生地</div>
            <div class="maskItem" @click="birthplace(1)">城市</div>
            <div class="maskItem" @click="birthplace(0)">农村</div>
        </div>
        <div class="maskBox" v-if="onlyChildStatus" @click="onlyChildStatus=false">
            <div class="maskTitle" @click.stop>是否独生子女</div>

            <div class="maskItem" @click.stop>否，家中排行<input @click.stop type="number" v-model="scaleUserBespeakRegister.onlyChild" placeholder="请输入数字" @blur="onlyChildBlur"></div>
            <div class="maskItem" @click="onlyChild(0)">是</div>
        </div>
        <div class="maskBox" v-if="religiousBeliefsStatus" @click="religiousBeliefsStatus=false">
            <div class="maskTitle" @click.stop>宗教信仰</div>

            <div class="maskItem" @click.stop>有，具体是<input @click.stop type="text" v-model="scaleUserBespeakRegister.religiousBeliefs" placeholder="请输入宗教" @blur="religiousBeliefsBlur"></div>
            <div class="maskItem" @click="religiousBeliefs('0')">无</div>
        </div>
        <div class="maskBox" v-if="familyStateStatus" @click="familyStateStatus=false">
            <div class="maskTitle" @click.stop>家庭结构</div>
            <div class="maskItem" @click="familyState(0)">完整</div>
            <div class="maskItem" @click="familyState(1)">单亲</div>
            <div class="maskItem" @click="familyState(2)">重组家庭</div>
            <div class="maskItem" @click="familyState(3)">孤儿</div>
        </div>
        <div class="maskBox" v-if="parentMaritalStatus" @click="parentMaritalStatus=false">
            <div class="maskTitle" @click.stop>父母婚姻状况</div>
            <div class="maskItem" @click="parentMarital(0)">良好</div>
            <div class="maskItem" @click="parentMarital(1)">一般</div>
            <div class="maskItem" @click="parentMarital(2)">离婚</div>
            <div class="maskItem" @click="parentMarital(3)">再婚</div>
        </div>
        <div class="maskBox" v-if="familyEconomicStatus" @click="familyEconomicStatus=false">
            <div class="maskTitle" @click.stop>家庭经济条件</div>
            <div class="maskItem" @click="familyEconomic(3)">富裕</div>
            <div class="maskItem" @click="familyEconomic(0)">较好</div>
            <div class="maskItem" @click="familyEconomic(1)">一般</div>
            <div class="maskItem" @click="familyEconomic(2)">贫困</div>
        </div>
        <div class="maskBox" v-if="familyMentalIllnessStatus" @click="familyMentalIllnessStatus=false">
            <div class="maskTitle" @click.stop>家族精神类疾病史</div>
            <div class="maskItem" @click="familyMentalIllness(0)">无</div>
            <div class="maskItem" @click="familyMentalIllness(1)">有</div>
        </div>
        <div class="maskBox" v-if="familyHappyStatus" @click="familyHappyStatus=false">
            <div class="maskTitle" @click.stop>家庭氛围</div>
            <div class="maskItem" @click="familyHappy(0)">亲密</div>
            <div class="maskItem" @click="familyHappy(1)">融洽</div>
            <div class="maskItem" @click="familyHappy(2)">疏离</div>
            <div class="maskItem" @click="familyHappy(3)">紧张</div>
            <div class="maskItem" @click="familyHappy(4)">冲突</div>
        </div>
        <div class="maskBox" v-if="liveStateStatus" @click="liveStateStatus=false">
            <div class="maskTitle" @click.stop>寄养/留守经历</div>
            <div class="maskItem" :class="{active:item.status}" @click.stop="item.status=!item.status" v-for="item in liveStateList" :key="item.key">{{item.name}}</div>
            <!-- <div class="maskItem" @click="liveState(1)">学龄期0~6岁</div>
            <div class="maskItem" @click="liveState(2)">小学阶段6~12岁</div>
            <div class="maskItem" @click="liveState(3)">初中阶段13~15岁</div> -->
        </div>
        <div class="maskBox" v-if="majorSatisfactionStatus" @click="majorSatisfactionStatus=false">
            <div class="maskTitle" @click.stop>对本专业的满意度</div>
            <div class="maskItem" @click="majorSatisfaction(0)">非常满意</div>
            <div class="maskItem" @click="majorSatisfaction(1)">比较满意</div>
            <div class="maskItem" @click="majorSatisfaction(2)">一般</div>
            <div class="maskItem" @click="majorSatisfaction(3)">不太满意</div>
            <div class="maskItem" @click="majorSatisfaction(4)">非常不满意</div>
            <div class="maskItem" @click="majorSatisfaction(5)">无所谓</div>
        </div>

        <div class="maskBox" v-if="incidentStatus" @click="incidentStatus=false">
            <div class="maskTitle" @click.stop>是否经历了负性生活事件情况，如重要他人去世、被校园霸凌、失恋等</div>

            <div class="maskItem" @click="incident('0')">无</div>
            <div class="maskItem" @click="incident('1')">有，且接受过心理干预</div>
            <div class="maskItem" @click="incident('2')">有，未接受过心理干预</div>
            <div class="maskItem" @click.stop>其他<input @click.stop type="text" v-model="scaleUserBespeakRegister.incident" placeholder="请输入" @blur="incidentBlur"></div>
        </div>
        <div class="maskBox" v-if="selfInflictedStatus" @click="selfInflictedStatus=false">
            <div class="maskTitle" @click.stop>您是否曾自伤或自杀</div>
            <div class="maskItem" @click="selfInflicted(0)">否</div>
            <div class="maskItem" @click="selfInflicted(1)">自伤或自杀想法</div>
            <div class="maskItem" @click="selfInflicted(2)">自伤行为</div>
            <div class="maskItem" @click="selfInflicted(3)">自杀行为</div>
        </div>
        <div class="maskBox" v-if="selfMentalIllnessStatus" @click="selfMentalIllnessStatus=false">
            <div class="maskTitle" @click.stop>个人精神障碍史</div>
            <div class="maskItem" @click="selfMentalIllness('0')">无</div>
            <div class="maskItem" @click="selfMentalIllness('1')">小学时发现</div>
            <div class="maskItem" @click="selfMentalIllness('2')">初中时发现</div>
            <div class="maskItem" @click="selfMentalIllness('3')">高中时发现</div>
            <div class="maskItem" @click="selfMentalIllness('4')">大学时发现</div>
            <div class="maskItem" @click.stop>其他<input @click.stop type="text" v-model="scaleUserBespeakRegister.selfMentalIllness" placeholder="请输入" @blur="selfMentalIllnessBlur"></div>
        </div>
        <div class="maskBox" v-if="consultHistoryStatus" @click="consultHistoryStatus=false">
            <div class="maskTitle" @click.stop>咨询经历</div>
            <div class="maskItem" @click="consultHistory(0)">无</div>
            <div class="maskItem" @click="consultHistory(1)">有</div>
        </div>
        <div class="maskBox" v-if="pressureValueStatus" @click="pressureValueStatus=false">
            <div class="maskTitle" @click.stop>评估目前压力水平（请打分，10分水平最高）</div>
            <div class="maskItem" @click="pressureValue(1)">1分</div>
            <div class="maskItem" @click="pressureValue(2)">2分</div>
            <div class="maskItem" @click="pressureValue(3)">3分</div>
            <div class="maskItem" @click="pressureValue(4)">4分</div>
            <div class="maskItem" @click="pressureValue(5)">5分</div>
            <div class="maskItem" @click="pressureValue(6)">6分</div>
            <div class="maskItem" @click="pressureValue(7)">7分</div>
            <div class="maskItem" @click="pressureValue(8)">8分</div>
            <div class="maskItem" @click="pressureValue(9)">9分</div>
            <div class="maskItem" @click="pressureValue(10)">10分</div>
        </div>
        <div class="maskBox" v-if="troublesStatus" @click="troublesStatus=false">
            <div class="maskTop" @click.stop>目前主要问题（可多选）</div>
            <div class="troublesList">
                <div class="troublesItem" :class="{active:item.status}" v-for="item in troublesList" @click.stop="item.status=!item.status">{{item.name}}</div>
                <div class="maskBtn" @click="saveTroubles">保存</div>
            </div>
        </div>

        <div class="tipBox" v-if="tipStatus">
            <div class="tip">{{tip}}</div>
        </div>



    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                tipStatus:false,
                tip:'',
                troublesList:[
                    {
                        name:'学习困难',
                        status:false
                    },
                    {
                        name:'生涯规划',
                        status:false
                    },
                    {
                        name:'个性成长',
                        status:false
                    },
                    {
                        name:'适应问题',
                        status:false
                    },
                    {
                        name:'家庭问题',
                        status:false
                    },
                    {
                        name:'人际关系',
                        status:false
                    },
                    {
                        name:'恋爱情感',
                        status:false
                    },
                    {
                        name:'强迫',
                        status:false
                    },
                    {
                        name:'抑郁',
                        status:false
                    },
                    {
                        name:'焦虑',
                        status:false
                    },
                    {
                        name:'睡眠问题',
                        status:false
                    },
                    {
                        name:'其他',
                        status:false
                    },
                    {
                        name:'其他情绪困扰',
                        status:false
                    },
                ],
                liveStateList:[
                    {
                        name:'无',
                        key:0,
                        status:false
                    },
                    {
                        name:'学龄期0~6岁',
                        key:1,
                        status:false
                    },
                    {
                        name:'小学阶段6~12岁',
                        key:2,
                        status:false
                    },
                    {
                        name:'初中阶段13~16岁',
                        key:3,
                        status:false
                    },
                ],
                birthplaceStatus: false,
                onlyChildStatus: false,
                religiousBeliefsStatus: false,
                familyStateStatus: false,
                parentMaritalStatus: false,
                familyEconomicStatus: false,
                familyMentalIllnessStatus: false,
                familyHappyStatus: false,
                liveStateStatus: false,
                majorSatisfactionStatus: false,
                incidentStatus: false,
                selfInflictedStatus: false,
                selfMentalIllnessStatus: false,
                consultHistoryStatus: false,
                pressureValueStatus: false,
                troublesStatus: false,
                scaleUserBespeakRegister:{
                    birthPlace: '',
                    onlyChild: '',
                    religiousBeliefs: '',
                    address:'',
                    fatherAge:'',
                    fatherLive:'',
                    fatherWork:'',
                    fatherEducation:'',
                    motherAge:'',
                    motherLive:'',
                    motherWork:'',
                    motherEducation:'',
                    familyState:'',
                    parentMarital:'',
                    familyEconomic:'',
                    familyMentalIllness:'',
                    familyHappy:'',
                    liveState:'',
                    majorSatisfaction:'',
                    incident:'',
                    selfInflicted:'',
                    selfMentalIllness:'',
                    consultHistory:'',
                    pressureValue:'',
                    troubles:''
                },
                userBespeakDetail:{
                    scaleUserBespeak:{
                        serveType:''
                    },
                }
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isServeType(value){
                let arr=['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[value]
            },
            isBirthPlace(v){
                let arr = ['农村','城市']
                return arr[v]
            },
            isFamilyState(v){
                let arr = ['完整','单亲','重组家庭','孤儿']
                return arr[v]
            },
            isParentMarital(v){
                let arr = ['良好','一般','离婚','再婚']
                return arr[v]
            },
            isFamilyEconomic(v){
                let arr = ['较好','一般','贫困','富裕']
                return arr[v]
            },
            isFamilyMentalIllness(v){
                let arr = ['无','有']
                return arr[v]
            },
            isFamilyHappy(v){
                let arr = ['亲密','融洽','疏离','紧张','冲突']
                return arr[v]
            },
            isLiveState(v){
                let arr = ['无','学龄期0~6岁','小学阶段6~12岁','初中阶段13~16岁']
                return arr[v]
            },
            isConsultHistory(v){
                let arr = ['无','有']
                return arr[v]
            },
            isPressureValue(v){
                return v+'分'
            },
            isMajorSatisfaction(v){
                let arr = ['非常满意','比较满意','一般','不太满意','非常不满意','无所谓']
                return arr[v]
            },
            isSelfInflicted(v){
                let arr = ['否','自伤或自杀想法','自伤行为','自杀行为']
                return arr[v]
            },
            isOnlyChild(v){
                if(v===0){
                    return '是'
                }else if(v > 0){
                    return  `家中排行 ${v}`
                }
            },
            isReligiousBeliefs(v){
                if(v==='0'){
                    return '无'
                }else {
                    return  v
                }
            },
            isIncident(v){
                if(v==='0'){
                    return '无'
                }else if(v === '1'){
                    return '有，且接受过心理干预'
                }else if(v === '2'){
                    return '有，未接受过心理干预'
                }else{
                    return  v
                }
            },
            isSelfMentalIllness(v){
                if(v==='0'){
                    return '无'
                }else if(v==='1'){
                    return '小学时发现'
                }else if(v==='2'){
                    return '初中时发现'
                }else if(v==='3'){
                    return '高中时发现'
                }else if(v==='4'){
                    return '大学时发现'
                }else{
                    return  v
                }
            }
        },
        computed: {},
        methods: {
            showTip(v){
                this.tip=v;
                this.tipStatus=true;
                setTimeout(()=>{
                    this.tipStatus=false;
                },1500)
            },
            saveTroubles(){
              let arr = []
              this.troublesList.forEach(v=>{
                  if(v.status){
                      arr.push(v.name)
                  }
              })
                if(arr.length>0){
                    this.scaleUserBespeakRegister.troubles=JSON.stringify(arr)
                }else{
                    this.scaleUserBespeakRegister.troubles=''
                }

                this.troublesStatus=false
            },
            openOnlyChild(){
                this.onlyChildStatus = true;
                this.scaleUserBespeakRegister.onlyChild = '';
            },
            openReligiousBeliefs(){
                this.religiousBeliefsStatus = true;
                this.scaleUserBespeakRegister.religiousBeliefs = '';
            },
            openIncident(){
                this.incidentStatus = true;
                this.scaleUserBespeakRegister.incident = '';
            },
            openSelfMentalIllness(){
                this.selfMentalIllnessStatus = true;
                this.scaleUserBespeakRegister.selfMentalIllness = '';
            },
            religiousBeliefsBlur(){
                if(this.scaleUserBespeakRegister.religiousBeliefs===''){

                }else{
                    this.religiousBeliefsStatus=false
                }
            },
            selfMentalIllnessBlur(){
                if(this.scaleUserBespeakRegister.selfMentalIllness===''){

                }else{
                    this.selfMentalIllnessStatus=false
                }
            },
            incidentBlur(){
                if(this.scaleUserBespeakRegister.incident===''){

                }else{
                    this.incidentStatus=false
                }
            },
            onlyChildBlur(){
                if(this.scaleUserBespeakRegister.onlyChild===''){

                }else{
                    this.onlyChildStatus=false
                }
            },
            birthplace(n){
                this.scaleUserBespeakRegister.birthPlace = n;
            },
            parentMarital(n){
                this.scaleUserBespeakRegister.parentMarital = n;
            },
            familyState(n){
                this.scaleUserBespeakRegister.familyState = n;
            },
            familyEconomic(n){
                this.scaleUserBespeakRegister.familyEconomic = n;
            },
            familyMentalIllness(n){
                this.scaleUserBespeakRegister.familyMentalIllness = n;
            },
            familyHappy(n){
                this.scaleUserBespeakRegister.familyHappy = n;
            },
            liveState(n){
                this.scaleUserBespeakRegister.liveState = n;
            },
            consultHistory(n){
                this.scaleUserBespeakRegister.consultHistory = n;
            },
            pressureValue(n){
                this.scaleUserBespeakRegister.pressureValue = n;
            },
            majorSatisfaction(n){
                this.scaleUserBespeakRegister.majorSatisfaction = n;
            },
            selfInflicted(n){
                this.scaleUserBespeakRegister.selfInflicted = n;
            },
            onlyChild(n){
                this.scaleUserBespeakRegister.onlyChild = n;
                // this.birthplaceStatus=false;
            },
            religiousBeliefs(n){
                this.scaleUserBespeakRegister.religiousBeliefs = n;
                // this.birthplaceStatus=false;
            },
            selfMentalIllness(n){
                this.scaleUserBespeakRegister.selfMentalIllness = n;
                // this.birthplaceStatus=false;
            },
            incident(n){
                this.scaleUserBespeakRegister.incident = n;
                // this.birthplaceStatus=false;
            },
            async getUserBespeakDetail(id) {
                let obj = {}
                obj.bespeakId = id;
                obj.userId = localStorage.getItem('userId');
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getUserBespeakDetail.json", obj);
                if (data.status === 0) {
                    this.userBespeakDetail=data.userBespeakDetail;
                    if(data.userBespeakDetail.scaleUserBespeakRegister){
                        this.scaleUserBespeakRegister=data.userBespeakDetail.scaleUserBespeakRegister;
                        let arr = []
                        arr=this.scaleUserBespeakRegister.liveState&&this.scaleUserBespeakRegister.liveState.split(',')
                        arr.forEach(v=>{
                            this.liveStateList.forEach(va=>{
                                v==va.key&&(va.status=true)
                            })
                        })
                    }

                }else{
                    this.showTip(data.msg)
                }
            },
            next(){
                if(this.scaleUserBespeakRegister.birthPlace===''){
                    this.showTip('请您选择出生地')
                }else if(this.scaleUserBespeakRegister.onlyChild===''){
                    this.showTip('请您选择是否是独生子女')
                }else if(this.scaleUserBespeakRegister.religiousBeliefs===''){
                    this.showTip('请您选择宗教信仰')
                }else if(this.scaleUserBespeakRegister.address===''){
                    this.showTip('请您填写在杭住址')
                }else if(this.scaleUserBespeakRegister.fatherAge===''){
                    this.showTip('请您填写父亲年龄')
                }else if(this.scaleUserBespeakRegister.fatherLive===''){
                    this.showTip('请您选择父亲是否健在')
                }else if(this.scaleUserBespeakRegister.fatherWork===''){
                    this.showTip('请您填写父亲职业')
                }else if(this.scaleUserBespeakRegister.fatherWork===''){
                    this.showTip('请您填写父亲职业')
                }else if(this.scaleUserBespeakRegister.fatherEducation===''){
                    this.showTip('请您填写父亲学历')
                }else if(this.scaleUserBespeakRegister.motherAge===''){
                    this.showTip('请您填写母亲年龄')
                }else if(this.scaleUserBespeakRegister.motherLive===''){
                    this.showTip('请您选择母亲是否健在')
                }else if(this.scaleUserBespeakRegister.motherWork===''){
                    this.showTip('请您填写母亲职业')
                }else if(this.scaleUserBespeakRegister.motherEducation===''){
                    this.showTip('请您填写母亲学历')
                }else if(this.scaleUserBespeakRegister.familyState===''){
                    this.showTip('请您选择家庭结构')
                }else if(this.scaleUserBespeakRegister.parentMarital===''){
                    this.showTip('请您选择父母婚姻状况')
                }else if(this.scaleUserBespeakRegister.familyEconomic===''){
                    this.showTip('请您选择家庭经济条件')
                }else if(this.scaleUserBespeakRegister.familyMentalIllness===''){
                    this.showTip('请您选择有无家族精神类疾病史')
                }else if(this.scaleUserBespeakRegister.familyHappy===''){
                    this.showTip('请您选择家庭氛围')
                }else if(!this.liveStateList.find(el => el.status == true)){
                    this.showTip('请您选择寄养/留守经历')
                }else if(this.scaleUserBespeakRegister.majorSatisfaction===''){
                    this.showTip('请您选择对本专业的满意度')
                }else if(this.scaleUserBespeakRegister.incident===''){
                    this.showTip('请您选择是否经历了负性生活事件情况，如重要他人去世、被校园霸凌、失恋等')
                }else if(this.scaleUserBespeakRegister.selfInflicted===''){
                    this.showTip('请您选择是否曾自伤或自杀')
                }else if(this.scaleUserBespeakRegister.selfMentalIllness===''){
                    this.showTip('请您选择个人精神障碍史')
                }else if(this.scaleUserBespeakRegister.consultHistory===''){
                    this.showTip('请您选择咨询经历')
                }else if(this.scaleUserBespeakRegister.pressureValue===''){
                    this.showTip('请您选择评估目前压力水平')
                }else if(this.scaleUserBespeakRegister.troubles===''){
                    this.showTip('请您选择目前主要问题(可多选)')
                }else{
                    this.userDoBespeakRegister();
                }
            },
            async userDoBespeakRegister() {
                let obj = this.scaleUserBespeakRegister;
                obj.liveState = ''
                obj.userId=localStorage.getItem('userId')
                obj.bespeakId=this.$route.query.bespeakId
                this.liveStateList.forEach(v=>{
                    v.status&&(obj.liveState+=v.key+',')
                })

                obj.liveState=obj.liveState.slice(0,obj.liveState.length-1)
                let data = await getSources("/bear-scale/api/scaleUserBespeak/userDoBespeakRegister.json", obj);
                if (data.status === 0) {
                    this.$router.push(`agreement?bespeakId=${this.$route.query.bespeakId}`)
                }else{
                    this.showTip(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            this.getUserBespeakDetail(this.$route.query.bespeakId)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/serveInfo.vue?38941026